import { FiMoreVertical as _FiMoreVertical } from "@react-icons/all-files/fi/FiMoreVertical.js";
import React, { useCallback, useMemo, useState } from 'react';
import { Classes, Position } from '@blueprintjs/core';
import { Button, DropdownMenu, Menu, MenuItem, Tooltip } from 'core/components';
import { buildRowFilters, getRowFilterCandidates } from './rowFilters';
function itemText(candidate, label) {
  const text = `${label}: ${candidate.displayValue}`;
  return candidate.unfilterableReason ? /*#__PURE__*/React.createElement(Tooltip, {
    content: candidate.unfilterableReason
  }, text) : text;
}
function UdeRowActionsMenu({
  row,
  query,
  measurement,
  onAddFilters
}) {
  const [isOpen, setIsOpen] = useState(false);
  const candidates = useMemo(() => isOpen ? getRowFilterCandidates({
    query,
    measurement,
    row
  }) : [], [isOpen, query, measurement, row]);
  const filterable = candidates.filter(candidate => !candidate.unfilterableReason);
  const apply = useCallback((selected, include) => onAddFilters(buildRowFilters(selected), {
    include
  }), [onAddFilters]);
  const renderSubItems = include => candidates.map(candidate => /*#__PURE__*/React.createElement(MenuItem, {
    key: candidate.dimension,
    text: itemText(candidate, candidate.label),
    disabled: !!candidate.unfilterableReason,
    className: Classes.POPOVER_DISMISS,
    onClick: () => apply([candidate], include)
  }));
  const hasMultipleDimensions = query.dimensions.length > 1;
  return /*#__PURE__*/React.createElement(DropdownMenu, {
    isOpen: isOpen,
    onInteraction: setIsOpen,
    position: Position.BOTTOM_RIGHT,
    content: /*#__PURE__*/React.createElement(Menu, {
      style: {
        maxWidth: 400
      }
    }, /*#__PURE__*/React.createElement(MenuItem, {
      icon: "th-derived",
      text: "Include this in query",
      disabled: !filterable.length,
      className: Classes.POPOVER_DISMISS,
      onClick: () => apply(filterable, true)
    }, hasMultipleDimensions ? renderSubItems(true) : undefined), /*#__PURE__*/React.createElement(MenuItem, {
      icon: "exclude-row",
      text: "Exclude this in query",
      disabled: !filterable.length,
      className: Classes.POPOVER_DISMISS,
      onClick: () => apply(filterable, false)
    }, hasMultipleDimensions ? renderSubItems(false) : undefined))
  }, /*#__PURE__*/React.createElement(Button, {
    icon: _FiMoreVertical,
    minimal: true,
    color: "muted",
    small: true,
    ariaHaspopup: true,
    ariaLabel: "Row filter actions"
  }));
}
export default UdeRowActionsMenu;